import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchCheckedInVehicles } from "../../api/vehicles"

export const fetchCheckInVehicleForWorkshopThunk = createAsyncThunk(
  "FETCH_CHECK_IN_VEHICLE_FOR_WORKSHOP",
  async (workshopId: string, { rejectWithValue }) => {
    try {
      return await fetchCheckedInVehicles(workshopId)
    } catch (error) {
      return rejectWithValue("There was an error fetching vehicles")
    }
  }
)